/*
**  rui-record-detail-block.js
**
**  rui-record-detail-block component
*/
import { LitElement, html, css } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map';
export class RuiRecordDetailBlock extends LitElement {
    static get is() {
        return 'rui-record-detail-block';
    }
    static get properties() {
        return {
            _width: { type: String, attribute: false }
        };
    }
    constructor() {
        super();
        this._width = 'medium';
    }
    render() {
        const width = this._width.toLowerCase();
        const classes = {
            ['rui-record-detail-column']: true,
            ['rui-record-detail-column-narrow']: width === 'narrow',
            ['rui-record-detail-column-wide']: width === 'wide',
            ['rui-record-detail-column-full']: width === 'full'
        };
        return html `
            <dl class="${classMap(classes)}">
                <slot></slot>
            </dl>
        `;
    }
    static get styles() {
        return css `
            :host {
                display: block;
            }
            
            .rui-record-detail-column {
                width: 350px;
                margin: 0 66px 20px 0;
            }
            
            .rui-record-detail-column-narrow {
                width: 250px;
            }
            
            .rui-record-detail-column-wide {
                width: 450px;
            }
            
            .rui-record-detail-column-full {
                width: 100%;
            }
            
            @media only screen and (max-width: 600px) {
                :host,
                .rui-record-detail-column,
                .rui-record-detail-column-narrow,
                .rui-record-detail-column-wide {
                    width: 100%;
                    margin: 0 0 20px 0;
                }
            }
        `;
    }
}
customElements.get(RuiRecordDetailBlock.is) || customElements.define(RuiRecordDetailBlock.is, RuiRecordDetailBlock);
